import { Table, Typography } from 'antd'

const { Title } = Typography

const FinancialsFilings = ({ propData }) => {
  const financialsData = [
    {
      attribute: 'Revenue',
      value: propData?.revenue,
    },
    {
      attribute: 'Net Income',
      value: propData?.net_income,
    },
    {
      attribute: 'Total Assets',
      value: propData?.total_assets,
    },
    {
      attribute: 'Total Liabilities',
      value: propData?.total_liabilities,
    },
    {
      attribute: `Stockholder's Equity`,
      value: propData?.stock_holders_equity,
    },
  ]
  const financialsColumns = [
    {
      title: 'Attribute',
      dataIndex: 'attribute',
      key: 'attribute',
      render: (text) => <b>{text}</b>,
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
      render: (text) => {
        return text
      },
    },
  ]
  const filingDateReceived = propData?.date_received.split(',')
  const filingLink = propData?.filing_link.split(',')
  const formType = propData?.form_type.split(',')

  const filingsColumns = [
    {
      title: 'Company Name',
      dataIndex: 'company_name',
      key: 'company_name',
    },
    {
      title: 'Date Received',
      dataIndex: 'date_received',
      key: 'date_received',
    },
    {
      title: 'Form Type',
      dataIndex: 'form_type',
      key: 'form_type',
    },
    {
      title: 'View',
      dataIndex: 'view',
      key: 'view',
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer">
          Link
        </a>
      ),
    },
  ]
  const filingsDataSource = filingDateReceived
    .filter((item) => item.length !== 0)
    .map((item, i) => {
      return {
        key: i,
        company_name: propData?.name,
        date_received: item,
        form_type: formType[i],
        view: filingLink[i],
      }
    })

  return (
    <>
      <Title className="title-wrapper">Company Financials</Title>
      <Table
        columns={financialsColumns}
        dataSource={financialsData}
        bordered
        showHeader={false}
        pagination={false}
      />
      <br />
      <Title className="title-wrapper">Company Filings</Title>
      <Table
        bordered
        dataSource={filingsDataSource}
        columns={filingsColumns}
        pagination={false}
      />
    </>
  )
}
export default FinancialsFilings
